import React, { Component } from 'react'
import { Modal, Form, Button, Popconfirm } from 'antd'
import ReverseForm from './ReverseForm'

const CollectionCreateForm = Form.create({ name: 'reverse' })(

  class extends Component {
    render() {
      const { visible, isSubmit, onCancel, onCreate, form, editableData } = this.props
      const { getFieldDecorator } = form
      return (
        <Modal
          visible={visible}
          maskClosable={false}
          title={`Reverse Payment`}
          onCancel={onCancel}
          onOk={onCreate}
          footer={[
            <Button key="back" onClick={onCancel}>Cancel</Button>,

            <Popconfirm
              // placement="bottomLeft"
              title={`Are you sure you want to add top topup for this customer?`}
              onConfirm={onCreate}
            >
              <Button key="submit" type="primary" loading={isSubmit} >
                {"Reverse"}
              </Button>
            </Popconfirm>
          ]}
        >
          <ReverseForm
            {...editableData}
            showModal={visible}
            getFieldDecorator={getFieldDecorator}
          />
        </Modal>
      )
    }
  }
)

export default class TopupModal extends Component {
  render() {
    const { shoModal, isSubmit, handleCancel, handleCreate, saveFormRef, editableData } = this.props
    return (
      <CollectionCreateForm
        wrappedComponentRef={saveFormRef}
        visible={shoModal}
        isSubmit={isSubmit}
        onCancel={handleCancel}
        onCreate={handleCreate}
        editableData={editableData}
      />
    )
  }
}
